import React from "react"
import { Link, graphql } from "gatsby"

import Bio from "../components/Bio"
import Layout from "../components/Layout"
import SEO from "../components/seo"
import ProjectList from "../components/ProjectList"
import { rhythm, scale } from "../utils/typography"
import PostList from "../components/PostList"

const filterByType = (type, data) =>
  data.allMarkdownRemark.edges.filter(
    edge =>
      edge.node.fileAbsolutePath.includes(type) && !edge.node.frontmatter.draft
  )

class BlogIndex extends React.Component {
  render() {
    const { data } = this.props
    const siteTitle = data.site.siteMetadata.title
    const posts = filterByType("content/blog/", data)
    const projects = filterByType("content/projects/", data)

    return (
      <Layout location={this.props.location} title={siteTitle}>
        <SEO
          title="Home"
          keywords={[
            "carl barrdahl",
            "web developer",
            "javascript",
            "react",
            "graphql",
            "web developer consultant",
            "software engineer"
          ]}
        />
        <Bio />
        <ProjectList projects={projects} />
        {/* <PostList posts={posts} /> */}
      </Layout>
    )
  }
}

export default BlogIndex

export const pageQuery = graphql`
  query {
    site {
      siteMetadata {
        title
      }
    }
    allMarkdownRemark(sort: { fields: [frontmatter___date], order: DESC }) {
      edges {
        node {
          fileAbsolutePath
          excerpt
          fields {
            slug
          }
          frontmatter {
            date(formatString: "MMMM DD, YYYY")
            title
            tags
            draft
          }
        }
      }
    }
  }
`
